export default "/react/logoTelegApp-9d39f358.png";